
import {
  FETCH_SCRATCHCARD_QUESTION_API_SUCCESS,
  FETCH_SCRATCHCARD_QUESTION_API_ERROR,
  FETCH_SCRATCHCARD_RULES_API_CONTENT,
  UPDATE_QUIZ_LOST_AND_ELIGABLE_TO_PLAY,
  UPDATE_QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY,
  UPDATE_QUIZ_OWNED_AND_ELIGABLE_TO_PLAY,
  UPDATE_QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY
} from '../constants/scratchCardConstants';

const initialState = {
  quiz: {
    data: { earnRewardStatus: null },
    apiStatus: '',
    apiStatusMessage: ''
  },
  answer: {
    data: {},
    apiStatus: '',
    apiStatusMessage: ''
  },
  rules: {
    data: [],
    apiStatus: '',
    apiStatusMessage: ''
  }
};

export default function scratchCardReducer(state = initialState, action = {}) {
  const { type: actionType = '', data = {} } = action;
  switch (actionType) {
    case FETCH_SCRATCHCARD_QUESTION_API_SUCCESS:
      return { ...state, quiz: { ...state.quiz, ...data } };
    case FETCH_SCRATCHCARD_QUESTION_API_ERROR:
      return { ...state, quiz: { ...state.quiz, ...data } };
    case UPDATE_QUIZ_LOST_AND_ELIGABLE_TO_PLAY:
      return { ...state, quiz: { ...state.quiz, data: { ...state.quiz.data, ...data } } };
    case UPDATE_QUIZ_LOST_AND_NOT_ELIGABLE_TO_PLAY:
      return { ...state, quiz: { ...state.quiz, data: { ...state.quiz.data, ...data } } };
    case UPDATE_QUIZ_OWNED_AND_ELIGABLE_TO_PLAY:
      return { ...state, quiz: { ...state.quiz, data: { ...state.quiz.data, ...data } } };
    case UPDATE_QUIZ_OWNED_AND_NOT_ELIGABLE_TO_PLAY:
      return { ...state, quiz: { ...state.quiz, data: { ...state.quiz.data, ...data } } };
    case FETCH_SCRATCHCARD_RULES_API_CONTENT:
      return { ...state, rules: { ...data } };
    default:
      return state;
  }
}
